import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/node_modules/@splidejs/react-splide/dist/css/splide-core.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/codebuild/output/src1214854546/src/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/src/app/(public)/sportsbooks/[slug]/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/app/(public)/sportsbooks/star-rating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/ExternalLinksHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/sportsbook/collapsible-offers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/sportsbook/mobile-table-of-contents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/sportsbook/sticky-bottom-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/sportsbook/table-of-contents.tsx");
